const pages = [
  {
    groupTitle: 'Deal Copilot',
    id: 'main',
    pages: [
      {
        title: 'Invite Customer',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/invite',
      },
      {
        title: 'Global Configs',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/global-configs',
      },
      {
        title: 'Organizations v2',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/orgn/v2',
      },
      {
        title: 'Roleplays(Users)',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/practice-calls',
      },
      {
        title: 'Discovery Trees',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/orgn/qf',
      },
      {
        title: 'Prompts v2',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/prompts/v2',
      },
      {
        title: 'Conversation Prompts',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/prompts/v1',
      },
      {
        title: 'Bots',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/bots',
      },
      {
        title: 'Rag Documents',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/rag-documents',
      },
      {
        title: 'Rag Queries',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/rag-queries',
      },
      {
        title: 'Fine Tune Models',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/fine-tune-models',
      },
      {
        title: 'Feature Previews',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/fp',
      },
      {
        title: 'Bounced Emails',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/bounced-emails',
      },
      {
        title: 'Recall Bot Usage',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/recall-bot-usage',
      },
      {
        title: 'AI Simulations',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/simulations',
      },
    ],
  },
  {
    groupTitle: 'Main',
    id: 'main',
    pages: [
      {
        title: 'Invite Users',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/inviteUser',
      },
      {
        title: 'Whitelabel Customers',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/customers',
      },
      {
        title: 'Whitelabel Clients',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/clients',
      },
      {
        title: 'Organizations',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/org/v1',
      },
      {
        title: 'Users',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/users',
      },
      {
        title: 'Practice Call Links',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/practice-call-links',
      },
      {
        title: 'Preset Questions',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/preset-questions',
      },
    ],
  },
  {
    groupTitle: 'Secondary',
    id: 'secondary',
    pages: [
      {
        title: 'Default Verticals & Designations',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/dvd',
      },
      {
        title: 'Plans & Add-ons',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/all-plans',
      },
      {
        title: 'Playbook Generation',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/playbook-generation',
      },
      {
        title: 'Privacy Policy & ToS',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/privacy-tos',
      },
      {
        title: 'Sales Call Analysis(Users)',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/sales-call-analysis-users',
      },
      {
        title: 'Sales Call Analysis(Admin)',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/sales-call-analysis',
      },
      {
        title: 'Roleplays(Admin)',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/practice-calls-admin',
      },
      {
        title: 'Bots Requests',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/bots-requests',
      },
      {
        title: 'Demo Requests',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/demo-requests',
      },
      {
        title: 'AWS transcribe poc',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/aws-transcribe-poc',
      },
      {
        title: 'Frontend Transcribe POC',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/fe-transcribe-poc',
      },
      {
        title: 'Playwright Test Reports',
        href: '/f550aeea-0bb4-41e9-b615-7a6cf101e740/test-reports',
      },
    ],
  },
];

export default pages;
